export const API_BASE_URL = '/api/generic-onboarding/v1/';

export enum PathApi {
  RATE = 'rate',
  CREATE = 'create',
  UPDATE = 'update',
  QUOTE = 'quote',
  QUOTE_RENEWAL = 'quote-renewal',
  BUY = 'buy',
  BIND_WITH_OTP = 'bind-with-otp',
  RETRIEVE_SALES = 'retrieve/sales',
}

export const SESSION_ID_HEADER_NAME = 'x-session-id';
export const PRODUCT_ID_HEADER_NAME = 'x-product-id';
export const TENANT_ID_HEADER_NAME = 'x-tenant-id';
